import React from 'react';
import { Modal } from 'antd';
import { FormProvider } from 'react-hook-form';
import { useSimulateThrottleCSV } from '../../../../mutation/mail';
import useSimulateThrottleCSVForm from './useSimulateThrottleCSVForm';
import SimulateThrottleCSVForm from './SimulateThrottleCSVForm';

export default function SimulateThrottleCSVModal({ isVisible, onClose }) {
  const { isLoading, mutateAsync } = useSimulateThrottleCSV();

  const form = useSimulateThrottleCSVForm();

  const handleSubmit = () => {
    const { file, isMultiMode, templateId, targetDate } = form.getValues();
    mutateAsync({
      file,
      payload: { isMultiCSV: isMultiMode, template_id: templateId, targetDate },
    }).then(() => {
      form.setValue('file', null);
      onClose();
    });
  };

  return (
    <FormProvider {...form}>
      <Modal
        closable={!isLoading}
        maskClosable={!isLoading}
        okButtonProps={{
          disabled: !form.formState.isValid || isLoading,
          loading: isLoading,
        }}
        title="Run throttling simulation on csv"
        visible={isVisible}
        width={800}
        onCancel={onClose}
        onOk={handleSubmit}
      >
        <SimulateThrottleCSVForm />
      </Modal>
    </FormProvider>
  );
}
